export default {
      id: "icon--gloves-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--gloves-usage",
      toString: function () {
        return this.url;
      }
    }